export default __webpack_public_path__ + "static/media/8.c0fc0a8f.svg";